import { Platform } from "react-native";
import { useEffect } from "react";

const CrispSupportScript = () => {
  useEffect(() => {
    if (Platform.OS === "web") {
      const script3 = document.createElement("script");
      script3.innerHTML = `window.$crisp=[];window.CRISP_WEBSITE_ID="${process.env.EXPO_PUBLIC_CRISP_WEBSITE_ID}";(function(){d=document;s=d.createElement("script");s.src="https://client.crisp.chat/l.js";s.async=1;d.getElementsByTagName("head")[0].appendChild(s);})();`;
      document.head.appendChild(script3);
    }
  }, []);

  return null;
};

export default CrispSupportScript;
